import axios from "axios";
import toast from "react-hot-toast";

const ApiRoot = `${process.env.REACT_APP_RULES_API_ROOT}/workstream`;

async function getAllWorkstreamsAsync() {
	try {
		const result = await axios.get(ApiRoot);
		return result.data;
	} catch {
		toast.error("Error listing workstreams please try again");
		return [];
	}
}

export default getAllWorkstreamsAsync;
